import App from './App.svelte';
import "noty/lib/noty.css";
import "noty/lib/themes/sunset.css";
const app = new App({
    target: document.body
});
export default app;
